module.exports = __webpack_public_path__ + "static/media/icw_list_img1.dff63df3.svg";